<template>
  <div id="app">
    <b-modal id="my-modal" scrollable  hide-footer ref="myModal">
      <ContactForm :closeModal="closeModal"></ContactForm>
    </b-modal>
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
    }
  },
  methods: {
    closeModal() {
      this.$refs.myModal.hide();
    }
  }
}
</script>

<style lang="scss">
.modal-dialog .modal-content {
  width: 80rem;
  max-width: 100%;
}
.modal-header {
  .close {
    font-size: 2.4rem;
  }
}
.carousel-inner,
.carousel-item {
  height: 100% !important;
}
@media (min-width: 1280px) {
  .modal .modal-dialog {
     max-width: 800px;
  }
}
@media (min-width: 767px) {
  .modal .modal-dialog {
     max-width: 700px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue